// @flow strict

import type { UpflowyStorageData } from './types';

export const setUpflowyDataStorage = (data: UpflowyStorageData) => {
  localStorage.setItem(data.signupUserId, JSON.stringify(data));
};

export const removeUpflowyDataStorage = (signupUserId: string) => {
  if (localStorage.getItem(signupUserId)) {
    localStorage.removeItem(signupUserId);
  }
};

export const getUpflowyDataStorage = (signupUserId: string): UpflowyStorageData => {
  const data = localStorage.getItem(signupUserId);
  const fallbackData = {};
  // $FlowFixMe
  return data ? JSON.parse(data) : fallbackData;
};
